import React from 'react'
import { SingleSelectComboboxString } from '../../../legacy-design-system/combobox'
import { StacktraceCaptureMode } from '../../servers-grid/shared'
import { ContrastFormattedMessage } from '../../contrast-formatted-message'

export function StacktraceCaptureModeInput({
  value,
  edited,
  onChange,
  isReadOnly
}: {
  value?: StacktraceCaptureMode
  onChange: (value: StacktraceCaptureMode) => void
  edited: boolean
  isReadOnly?: boolean
}) {
  return (
    <ContrastFormattedMessage id="title_stacktraces">
      {(labelStacktraces) => (
        <SingleSelectComboboxString<StacktraceCaptureMode>
          id="serverSettings_stacktraces"
          label={labelStacktraces}
          items={[{ items: ['ALL', 'SOME', 'NONE'] }]}
          value={value}
          onChange={onChange}
          edited={edited}
          disabled={isReadOnly}
        />
      )}
    </ContrastFormattedMessage>
  )
}
